import { useState, useEffect } from 'react'

interface PaymentMethod {
  method: string
}

interface PaymentMethodData {
  roundingDelta: number | null
}

interface PaymentMethodsData {
  [key: string]: PaymentMethodData[]
}

const useRoundingDelta = (
  paymentMethods: PaymentMethod[],
  paymentMethodsData: PaymentMethodsData,
  totalPaymentAmount?: number,
) => {
  const [roundingDelta, setRoundingDelta] = useState(0.0)

  useEffect(() => {
    // Exit early if there are no payment methods in the billId
    if (!paymentMethods || paymentMethods.length === 0) {
      setRoundingDelta(0.0)
      return
    }

    // Only apply rounding when all splits use methods that have rounding
    let round = true
    paymentMethods.forEach(pm => {
      if (paymentMethodsData[pm.method] && paymentMethodsData[pm.method][0].roundingDelta === null) {
        round = false
      }
    })

    if (round) {
      try {
        // since all payment methods have rounding, we can just use the first one
        // Note that once we have support for different rounding per payment method, this will need to change
        const delta = paymentMethodsData[paymentMethods[0].method][0].roundingDelta || 0.0
        setRoundingDelta(Number(delta))
      } catch (e) {
        setRoundingDelta(0.0)
      }
    } else {
      setRoundingDelta(0.0)
    }
  }, [paymentMethods, paymentMethodsData, totalPaymentAmount])
  return roundingDelta
}

export default useRoundingDelta
